<template>
  <div>
    <h3 class="mb-3">تنظیمات عمومی</h3>
    <BaseText
      title="نام بورد"
      class="mb-2"
      @input="boardName = $event"
      :value="boardName"
      inputType="text"
      placeholder="عنوان"
      :maxlength="30"
      :showError="showError"
      errortext="نام بورد الزامیست"
      required
    />
  </div>
</template>

<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
export default {
  components: {
    BaseText,
  },
  data() {
    return {
    }
  },
  props: {
    value: {
      default: null,
    },
    showError: {
      default: null,
      type: Boolean
    },
  },
  computed: {
    boardName: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('boardName', val)
      },
    },
  },
}
</script>

<style></style>
